import { isPrejoinEnabledInConfig } from '../../../react/features/prejoin/functions';
import { createConferenceJoinedEvent, createVisitorEvent } from './AnalyticsEvents';
import { sendStatsToKibana } from './kibana/actions';
import { sendEventByFilter } from './kinesis/actions';
export function sendVisitorEvent(eventData) {
    return (_dispatch, _getState) => {
        const event = createVisitorEvent(eventData);
        if (typeof APP === 'object') {
            _dispatch(sendEventByFilter(event));
        }
        _dispatch(sendStatsToKibana([event], event.subject));
    };
}
export function sendConferenceJoinedEvent(eventData = {}) {
    return (_dispatch, getState) => {
        const event = createConferenceJoinedEvent({
            ...eventData,
            prejoin: {
                enabled: isPrejoinEnabledInConfig(getState())
            }
        });
        _dispatch(sendStatsToKibana([event], event.subject));
    };
}
